'use client';
import { appPublicConfig } from '@/configs/appPublicConfig';
import { HelloeroCustomError } from '@/shared/components/features/errorPages/HelloeroCustomError';

export default function RootError() {
  return <HelloeroCustomError config={appPublicConfig} statusCode={500} />;
}
